{
  "ONBOARDING_NEXT": {
    "GREETING": "Ciao {name}!",
    "SUBTITLE": "Verifica i seguenti dettagli per favore",
    "YOUR_DETAILS": "I tuoi dati",
    "COMPANY_DETAILS": "Dati dell'azienda",
    "FIELDS": {
      "EMAIL": "Email",
      "YOUR_ROLE": "Il tuo Ruolo",
      "WEBSITE": "Sito Web",
      "LANGUAGE": "Lingua",
      "TIMEZONE": "Fuso Orario",
      "COMPANY_SIZE": "Dimensione Azienda",
      "INDUSTRY": "Settore",
      "REFERRAL_SOURCE": "Come ci hai trovati?"
    },
    "PLACEHOLDERS": {
      "SELECT_ROLE": "Seleziona il tuo ruolo",
      "ENTER_WEBSITE": "www.example.com",
      "SELECT_LANGUAGE": "Seleziona lingua",
      "SELECT_TIMEZONE": "Seleziona fuso orario",
      "SELECT_COMPANY_SIZE": "Seleziona dimensione azienda",
      "SELECT_INDUSTRY": "Seleziona settore",
      "SELECT_REFERRAL_SOURCE": "Seleziona origine"
    },
    "EMAIL_VERIFIED": "Email verificata",
    "SETTING_UP": "Configurazione del tuo account...",
    "CONTINUE": "Continua",
    "SAVING": "Salvataggio...",
    "VALIDATION_ERROR": "Per favore compila tutti i campi obbligatori",
    "SUCCESS": "Dati salvati correttamente",
    "ERROR": "Impossibile salvare i dati. Per favore riprova."
  },
  "ONBOARDING_INBOX_SETUP": {
    "GREETING": "Let's set up a few things",
    "SUBTITLE": "This will give you head-start in your workspace",
    "CONTINUE": "Continua",
    "SKIP": "Salta",
    "ERROR": "Qualcosa è andato storto. Per favore, riprova.",
    "WHATSAPP_CONNECTED": "WhatsApp connected successfully",
    "FACEBOOK_CONNECTED": "Facebook connected successfully",
    "CREATED_FOR_YOU": {
      "TITLE": "We've created the following for you",
      "LIVE_CHAT": "Live Chat widget",
      "LIVE_CHAT_DESCRIPTION": "Instant messenger for your website",
      "LIVE_CHAT_STATUS": "Almost done…",
      "LIVE_CHAT_READY": "Pronto",
      "HELP_CENTER": "Help Center",
      "HELP_CENTER_DESCRIPTION": "Your digital encyclopedia",
      "HELP_CENTER_GENERATING": "Creating your help center…",
      "HELP_CENTER_ANALYZING_WEBSITE": "Analyzing your website…",
      "HELP_CENTER_SETTING_UP_CATEGORIES": "Setting up categories…",
      "HELP_CENTER_CURATING_ARTICLES": "Curating articles…",
      "HELP_CENTER_ARTICLES": "Created {count} article | Created {count} articles",
      "HELP_CENTER_CATEGORIES": "{count} categoria | {count} categorie",
      "HELP_CENTER_SUMMARY": "Created {count} article across {categories} | Created {count} articles across {categories}"
    },
    "CHANNELS": {
      "TITLE": "Connect all your conversation channels",
      "HEADER": "We found a few channels you can connect",
      "CONNECT": "Connetti",
      "CONNECTED": "Connected",
      "MORE_CHANNELS_NOTE": "Set up {email} and {voice} channels later inside the app",
      "MORE_CHANNELS_EMAIL": "Email",
      "MORE_CHANNELS_VOICE": "Voce",
      "VIEW_ALL": "Vedi tutti",
      "GMAIL": "Gmail",
      "OUTLOOK": "Outlook",
      "OTHER_EMAIL": "Other Email Providers"
    },
    "CHANNELS_DIALOG": {
      "TITLE": "Connect all your channels instantly",
      "SUBTITLE": "Manage all of them from one dashboard. You can also set up and edit inboxes later inside the app.",
      "NOTE": "SMS, API, Voice, and other email providers can be set up later from your dashboard.",
      "CONNECT_TITLE": "Connect your {name} account",
      "CONNECT_SUBTITLE": "Fill out these quick details",
      "CONNECT": "Connetti",
      "BACK": "Indietro",
      "SETUP_LATER": "Setup later in app",
      "FACEBOOK_SUBTITLE": "Authorize access and choose a Page to connect.",
      "FACEBOOK_LAUNCH": "Continue with Facebook",
      "FACEBOOK_SELECT_PAGE": "Select a Page to connect",
      "FACEBOOK_LOADING": "Loading your Facebook Pages…",
      "FACEBOOK_NO_PAGES": "No connectable Pages found. All your Pages are already connected.",
      "FACEBOOK_ERROR": "Couldn't connect to Facebook. Please try again."
    }
  }
}
